import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { slide as Menu } from 'react-burger-menu';
import { toggleMenu } from '../../state/toggle/actions';
import { logout, showChangePasswordModal } from '../../state/auth/actions';

export const BurgerMenu = React.createClass({
  contextTypes: {
    location: React.PropTypes.object
  },

  isMenuOpen(state) {
    if (state.isOpen) {
      this.props.dispatch(toggleMenu(true));
    } else {
      this.props.dispatch(toggleMenu(false));
    }
  },

  openPasswordModal() {
    const { dispatch } = this.props;
    dispatch(toggleMenu(false));
    dispatch(showChangePasswordModal(true));
  },

  handleLogout() {
    this.props.dispatch(logout());
    this.props.dispatch(push('/'));
  },

  goToProfile() {
    const { dispatch } = this.props;
    dispatch(push('/profile'));
    dispatch(toggleMenu(false));
  },
  goToJobsList() {
    const { dispatch } = this.props;
    dispatch(push('/jobs'));
    dispatch(toggleMenu(false));
  },
  goToJobForm() {
    const { dispatch } = this.props;
    dispatch(push('/create-job'));
    dispatch(toggleMenu(false));
  },

  goToInvite() {
    const { dispatch } = this.props;
    dispatch(push('/invite'));
    dispatch(toggleMenu(false));
  },

  renderLogo() {
    let logoName = 'logo-light-bg.png';
    if (this.props.bgColor === 'dark') {
      logoName = 'logo-dark-bg.png';
    }
    return (
      <img
        className="nav-logo"
        src={`../../assets/navbar/${logoName}`}
        alt="Logo"
      />
    );
  },

  render() {
    return (
      <div className="side-menu ">
        <Menu
          customBurgerIcon={false}
          customCrossIcon={false}
          onStateChange={this.isMenuOpen}
          isOpen={this.props.isOpen}
          pageWrapId={this.props.pageWrapId}
          outerContainerId={this.props.outerContainerId}
        >
          <a
            className="menu-logo"
            onClick={() => this.props.dispatch(toggleMenu(false))}
          >
            {this.renderLogo()}
          </a>
          <hr />
          <ul className="menu-options">
            <li className="navigation link">
              <a onClick={this.goToProfile}>My Profile</a>
            </li>
            <li className="navigation link">
              <a onClick={this.goToJobsList}>View Jobs</a>
            </li>
            <li className="navigation link">
              <a onClick={this.goToJobForm}>Create Job</a>
            </li>
            <li className="navigation link">
              <a id="change-password-link" onClick={this.openPasswordModal}>
                Change Password
              </a>
            </li>
            <li className="navigation link">
              <a
                href={`mailto:fernando@nuancedinterpretation.com?subject=Help%20with%20Nuanced Interpretation%20Client%20Portal`}
              >
                Help
              </a>
            </li>
            <li className="navigation link">
              <a id="logout-link" onClick={this.handleLogout}>
                Logout
              </a>
            </li>
          </ul>
        </Menu>
      </div>
    );
  }
});

const mapStateToProps = state => ({
  isOpen: state.toggle.get('isOpen')
});

export const BurgerMenuContainer = connect(mapStateToProps)(BurgerMenu);



/** WEBPACK FOOTER **
 ** ./src/components/burger-menu/burger-menu.jsx
 **/